/* eslint-disable jsx-a11y/anchor-is-valid */

import {Link} from 'react-router-dom'
import {KTIcon} from '../../../../_metronic/helpers'

type Props = {
  id: number
  selectItem: (selectType: string, id: number) => void
}

const TicketActionCell = ({id, selectItem}: Props) => {
  const onAssign = () => selectItem('assign', id)
  const onReply = () => selectItem('reply', id)

  return (
    <div className='text-end'>
      <a
        href='#'
        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_2'
        onClick={onAssign}
        title='assign ticket'
      >
        <KTIcon iconName='user' className='fs-3' />
      </a>

      {/* <a
        href='#'
        className='btn btn-icon btn-bg-light btn-color-success btn-active-color-primary btn-sm me-1'
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_3'
        onClick={onReply}
        title='reply ticket'
      >
        <KTIcon iconName='text' className='fs-3' />
      </a> */}

      <Link
        to={`/ticket/view/${id}`}
        className='btn btn-icon btn-bg-light btn-color-info btn-active-color-primary btn-sm me-1'
        title='view query details'
      >
        <KTIcon iconName='eye' className='fs-3' />
      </Link>
    </div>
  )
}

export default TicketActionCell
